import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadModernization'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={
          'モダナイゼーション レガシーシステム刷新 クラウドネイティブ AI駆動開発 DX推進 システム移行 IT投資 デジタルシフト'
        }
        image={'https://aitria.co.jp/images/img/download/modernization/ogp.png'}
        url={'https://aitria.co.jp/download/modernization/'}
        title="失敗しないAI時代のモダナイゼーション戦略 | 資料ダウンロード | Aitria（アイトリア）"
        description="システムの老朽化や複雑化に悩む方向けに、モダナイゼーションの最新動向をまとめたガイドラインです。クラウドネイティブやAI駆動開発など、AI時代に欠かせない要素を整理し、プロジェクト計画から予算策定、パートナー選定まで幅広く活用できます。"
      />
      <Template />
    </>
  )
}

export default Download
